import { HeroCenter } from "../sections/HeroCenter";
import { SimpleFooter } from "../sections/SimpleFooter";
import { ImageRow } from "../components/ImageRow";
import { Card } from "../components/Card";
import { Cards } from "../sections/Cards";
import { HalfRow } from "../components/HalfRow";

import { BUSINESS_NAME } from "../constants/constants";

import diag from "../icons/DiagStripes.svg";
import timbertech from "../images/TimberTechPlatinumPro.png";

import hero from "../images/deckcommander_dronedeck_15.jpg";
import first from "../images/deckcommander_dronedeck_9.jpg";
import second from "../images/deckcommander_dronedeck_5.jpg";
import third from "../images/PoolDeck_1.png";

const Home = () => {
  return (
    <>
      <HeroCenter
        image={hero}
        businessName={BUSINESS_NAME}
        tagline={"Take Command of Your Backyard"}
        buttonText={"Contact Us"}
      />

      <section
        className={"text-md md:text-xl md:leading-loose text-primary-800"}
      >
        <HalfRow
          title={"Transform Your Backyard"}
          header={"Custom Deck Design and Installation"}
          element={
            <p>
              Our mission is simple: to design and build decks that suit your
              unique style, needs, and space. We understand that no two homes
              are alike, which is why we focus on personalized service, ensuring
              that your deck becomes an extension of your lifestyle. Let us help
              you create a space you'll love for years to come.
            </p>
          }
          isReversed={false}
          className={"bg-secondary-200"}
        />
        <HalfRow
          title={"Your Outdoor Space, Redefined"}
          header={"Decks Tailored to Your Needs"}
          element={
            <p>
              We specialize in building durable, beautiful decks for homeowners
              in the Milwaukee area of Wisconsin. From personalized
              consultations to expert craftsmanship, we work closely with you to
              design and build a backyard escape that perfectly complements your
              home and lifestyle.
            </p>
          }
          isReversed={true}
          className={"bg-secondary-100"}
        />
      </section>

      <section
        className={
          "text-pretty text-md md:text-xl md:leading-loose text-primary-800"
        }
      >
        <ImageRow
          image={first}
          underlay={diag}
          icon={timbertech}
          title={"Decks Built to Last"}
          header={"TimberTech Platinum Pro"}
          element={
            <p className={"pt-6 px-2"}>
              As a certified TimberTech installer, we offer premium composite
              decking that's sustainable, low maintenance, and built to
              withstand the elements. TimberTech supplies recycled composite
              deck materials that are extremely durable and will not fade,
              stain, splinter, crack, or rot.
            </p>
          }
          isReversed={false}
          className={"bg-secondary-200 pb-8 md:pb-0"}
        />
        <ImageRow
          image={second}
          underlay={diag}
          title={"Unparalleled Craftsmanship"}
          header={"10 Year Comprehensive Warranty"}
          element={
            <p className={"pt-6 px-2"}>
              Every deck we build is a testament to our dedication to quality
              and innovation. We have such a high degree of confidence in our
              worksmanship that we offer a ten year comprehensive warranty with
              every deck build. With advanced training from Azek University, our
              crews ensure the job gets done right the first time.
            </p>
          }
          isReversed={true}
          className={"bg-secondary-100 pb-8 md:pb-0"}
        />
        <ImageRow
          image={third}
          underlay={diag}
          title={"General Contracting"}
          header={"Comprehensive Home Improvement Services"}
          element={
            <div
              className={"flex flex-col pt-6 px-2 items-center md:items-start"}
            >
              <p>
                We also provide a variety of general contracting services, such
                as:
              </p>
              <ul
                className={
                  "flex flex-col list-[circle] text-left pt-4 md:pl-10"
                }
              >
                {[
                  "Roofing, siding, and windows",
                  "Gutters, soffits, and fascia",
                  "Additions, remodels, and new construction",
                ].map((s) => {
                  return <li>{s}</li>;
                })}
              </ul>
            </div>
          }
          isReversed={false}
          className={"bg-secondary-200 pb-8 md:pb-0"}
        />
      </section>

      <Cards
        title={"Experience the Deck Commander Difference"}
        text={
          "At Deck Commander, we bring expertise, precision, and passion to every project, delivering stunning decks that elevate your outdoor space."
        }
        className={"bg-secondary-100"}
      >
        <Card
          title={"Transparent Process"}
          text={
            "From the initial consultation to the final walkthrough, we keep you informed every step of the way to ensure your vision comes to life."
          }
          className={"bg-secondary-200"}
        />
        <Card
          title={"Built on Expertise"}
          text={
            "With specialized training through Azek University and years of experience, we bring unparalleled skill and precision to every project."
          }
          className={"bg-secondary-200"}
        />
        <Card
          title={"Eco-Friendly Practices"}
          text={
            "As a certified TimberTech installer, we prioritize sustainable materials and environmentally friendly construction methods."
          }
          className={"bg-secondary-200"}
        />
      </Cards>

      <SimpleFooter backgroundColor={"bg-secondary-200"} />
    </>
  );
};

export default Home;
